import { Hiking } from '@mui/icons-material';
import { Typography, Link, Grid } from '@mui/material';
import { Box } from '@mui/system';
import { Link as RouterLink } from 'react-router-dom';
import StandardPage from '~/layouts/StandardPage';

function PageNotFound() {
  return (
    <StandardPage
      bannerContent={
        <div className='bluebg textBox-transparent'>
          <Typography variant='h3'>Page not found.</Typography>
        </div>
      }
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="50vh"
      >
        <Grid container spacing={2} justifyContent="center">
          <Grid item>
            <Link component={RouterLink} to="/" underline="none" color="secondary">
              <Hiking sx={{ fontSize: 130 }} color="primary" />
            </Link>
          </Grid>
          <Grid item>
            <Typography variant="h4" gutterBottom>
              Are you lost?
            </Typography>
            <Typography variant="h6">
              <Link component={RouterLink} to="/" underline="none" color="secondary">
                Click here to return home and search for flights or trips.
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </StandardPage>
  );
}

export default PageNotFound;
